import { render } from "./MagentoLogoIcon.vue?vue&type=template&id=48085115"
import script from "./MagentoLogoIcon.vue?vue&type=script&lang=js"
export * from "./MagentoLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__